<template>
	<sg-modal
		v-model="isOpen"
		:title="$t('main-map.options-title')"
		header-color="branding"
	>
		<div class="p-4">
			<ion-list>
				<ion-item>
					<ion-label>{{ $t("main-map.show-regions") }}</ion-label>
					<ion-toggle slot="end" v-model="showRegions" />
				</ion-item>
			</ion-list>
		</div>

		<template #footer>
			<ion-button slot="end" @click="isOpen = false">
				{{ $t("common.done") }}
			</ion-button>
		</template>
	</sg-modal>
</template>

<script setup lang="ts">
	import {
		IonList,
		IonItem,
		IonLabel,
		IonToggle,
		IonButton,
	} from "@ionic/vue";
	import SgModal from "@/components/ui/modals/SgModal.vue";

	const isOpen = defineModel<boolean>({ default: false });
	const showRegions = defineModel<boolean>("showRegions", { default: false });
</script>
